<template>
  <div class="row">
    <div class="col-md-6 offset-md-3 col-sm-10 offset-sm-1">
      <form id="register-form" role="form">
        <h3 class="text-center">Registrarse</h3>
        <div class="form-group">
          <input
            type="email"
            class="form-control"
            :class="{'is-invalid': !validUsername.result}"
            placeholder="Correo"
            v-model="form.username"
          />
          <div class="invalid-feedback">{{ validUsername.message }}</div>
        </div>
        <div class="form-group">
          <input
            type="password"
            class="form-control"
            :class="{'is-invalid': !validPassword.result}"
            placeholder="Contraseña"
            v-model="form.password"
          />
          <div class="invalid-feedback">{{ validPassword.message }}</div>
        </div>
        <div class="form-group">
          <select v-model="form.TypeDocId" class="form-control" id="exampleFormControlSelect1">
            <option
              v-for="(typeDoc, index) in typeDocs"
              :key="index"
              :value="typeDoc.id"
            >{{ typeDoc.description }} ({{ typeDoc.name }})</option>
          </select>
        </div>
        <div class="form-group">
          <input
            type="number"
            class="form-control"
            :class="{'is-invalid': !validDocNumber.result}"
            placeholder="Documento de identidad"
            v-model="form.docNumber"
          />
          <div class="invalid-feedback">{{ validDocNumber.message }}</div>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="Nombre"
            :class="{'is-invalid': !validName.result}"
            v-model="form.name"
          />
          <div class="invalid-feedback">{{ validName.message }}</div>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="Apellido"
            :class="{'is-invalid': !validLastName.result}"
            v-model="form.lastName"
          />
          <div class="invalid-feedback">{{ validLastName.message }}</div>
        </div>
        <div class="form-group">
          <vue-tel-input
            placeholder="Teléfono"
            @input="onPhoneInput"
            :wrapperClasses="['form-control', {'is-invalid': !validPhone}]"
          />
          <div class="invalid-feedback">Teléfono no válido</div>
        </div>
        <div class="form-group">
          <button
            class="btn btn-success"
            style="width: 100%"
            @click.prevent="registerClient"
            :disabled="isLoading || disabled"
          >
            <i v-if="isLoading" class="fa fa-spinner fa-spin" />
            Registrarse
          </button>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-lg-12">
              <div class="text-center">
                <router-link to="/login">
                  <a>Login</a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { registerClientApi, getTypeDocsApi } from "../../api/modules";
import { isValidField } from "@/utils/formValidation";
import { VueTelInput } from "vue-tel-input";
export default {
  components: {
    VueTelInput
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
        docNumber: "",
        name: "",
        lastName: "",
        phoneNumber: "",
        TypeDocId: 1
      },
      validPhone: false,
      isLoading: false,
      typeDocs: []
    };
  },
  computed: {
    disabled() {
      return !(
        this.validUsername.result &&
        this.validPassword.result &&
        this.validDocNumber.result &&
        this.validName.result &&
        this.validLastName.result &&
        this.validPhone
      );
    },
    validUsername() {
      return isValidField(this.form.username, ["required", "email"]);
    },
    validDocNumber() {
      return isValidField(this.form.docNumber, ["required"]);
    },
    validPassword() {
      return isValidField(this.form.password, ["required", { minLength: 8 }]);
    },
    validName() {
      return isValidField(this.form.name, ["required"]);
    },
    validLastName() {
      return isValidField(this.form.lastName, ["required"]);
    }
  },
  created() {
    this.getTypeDocs();
  },
  methods: {
    ...mapActions(["clearMessage", "addMessage"]),
    async getTypeDocs() {
      let serviceResponse = await getTypeDocsApi();
      if (serviceResponse.status) this.typeDocs = serviceResponse.data;
      else {
        let message_obj = {
          message: serviceResponse.message.text,
          messageClass: "danger",
          autoClose: true
        };
        this.addMessage(message_obj);
      }
    },
    async registerClient() {
      const body = {
        ...this.form,
        name: this.form.name + " " + this.form.lastName
      };
      let serviceResponse = await registerClientApi(body);
      let message_obj = {
        message: serviceResponse.message.text,
        autoClose: true
      };
      message_obj.messageClass = serviceResponse.status ? "success" : "danger";
      this.addMessage(message_obj);
      if (serviceResponse.status)
        this.$router.push({
          name: "login"
        });
    },
    onPhoneInput(_, { number: { e164 }, isValid }) {
      this.form.phoneNumber = e164;
      this.validPhone = isValid;
    }
  }
};
</script>
